/**
 * Severe Weather Module Configuration
 *
 * Central hub for severe weather risk data across property portfolios.
 * v1: Hail forecast from NOAA SPC Day 1/2/3 outlooks.
 * Future: tornado paths, wind damage, confirmed post-storm events.
 *
 * @see .context/WEB-APP.md for architecture documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const severeWeatherModule: AppModule = {
    id: 'severe-weather',

    navigation: {
        label: 'Severe Weather',
        icon: 'cloud-lightning',
        path: '/severe-weather',
        order: 30,
        moduleKey: 'severe_weather',


        // Only show when xweather integration is enabled
        requiresIntegration: 'xweather',

        pages: [
            {
                label: 'Severe Weather Forecast',
                path: '/severe-weather',
                icon: 'cloud-hail',
            },
            {
                label: 'Weather Events',
                path: '/severe-weather/events',
                icon: 'cloud-rain-wind',
                requiresIntegration: 'xweather',
            },
            {
                label: 'Weather Reports',
                path: '/severe-weather/reports',
                icon: 'file-text',
                requiresIntegration: 'xweather',
            },
            {
                label: 'Leads',
                path: '/severe-weather/leads',
                icon: 'users',
                requiresIntegration: 'xweather',
            },
        ],
    },

    routes,
}

export default severeWeatherModule
